import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const touchPersonalChat = mutator({
  schema: z.object({
    id: z.string(),
  }),
  resolve: {},
  permissions: {
    none: "personal chats are read and written only for ctx.userId",
  },
  fn: async ({ tx, ctx, args: { id } }) => {
    const { userId } = ctx;
    const [pc] = await tx.run(
      zql.personalChats.where("id", id).where("userId", userId)
    );
    if (!pc) return;
    await tx.mutate.personalChats.update({
      id,
      lastActiveAt: Date.now(),
    });
  },
});
